<template functional>
    <footer class="the-footer bg-light pb-24 xl:pb-12" :class="classes">
      <section class="vx-row justify-center w-full">
        <div class="vx-col w-5/6">
          <main class="vx-row justify-center w-full">
            <!-- / -->
            <div class="vx-col w-full lg:w-2/3 mt-24">
              <div class="vx-row justify-start">
                <ul class="vx-col w-full md:w-1/2 lg:w-1/3 mb-4 md:mb-0">
                  <li class="mb-2">
                    <router-link to="/about" class="text-primary">Tentang ZX</router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/sahabat-zx" class="text-primary">Sahabat ZX</router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/promo" class="text-primary">Promo</router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/zxcare" class="text-primary">ZX Care</router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/faq" class="text-primary"><strong>Bantuan dan Panduan</strong></router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/terms-conditions" class="text-primary">Syarat dan Ketentuan</router-link>
                  </li>
                  <li class="mb-2">
                    <router-link to="/privacy-policy" class="text-primary">Kebijakan dan Privasi</router-link>
                  </li>
                </ul>
                <section class="vx-col w-full md:w-1/2">
                  <h5 class="mb-4 text-primary"><b>Ikuti Kami</b></h5>
                  <div class="flex items-center">
                    <img src="/assets/images/footer/ig.svg" alt="" class="w-12 px-2" />
                    <img src="/assets/images/footer/fb.svg" alt="" class="w-12 px-2" />
                    <img src="/assets/images/footer/tiktok.svg" alt="" class="w-12 px-2" />
                    <img src="/assets/images/footer/yt.svg" alt="" class="w-12 px-2" />
                  </div>
                </section>
              </div>
              <div class="block lg:hidden pt-12">
                <p class="text-primary text-center flex items-center">
                  <img src="/green-logo.png" class="w-12 mr-3" alt="" />
                  <small>&copy; 2009-2022, PT Inti Smart Solution</small>
                </p>
              </div>
            </div>
            <div class="vx-col hidden lg:block w-1/3 flex justify-end">
              <div class="py-24"></div>
              <div class="py-12"></div>
              <div class="py-8"></div>
              <p class="text-primary copyright text-right flex items-center">
                <img src="/green-logo.png" class="w-12 mr-3" alt="" />
                <small>&copy; 2009-2022, PT Inti Smart Solution</small>
              </p>
              
            </div>
          </main>
        </div>
            
      </section>
        
    </footer>
</template>
<style>
  .bg-footer {
    background-image: url('/assets/images/footer/bg.svg');
    background-repeat: no-repeat;
    background-size: cover;
  }
  .lazy-load {

  }
</style>
<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
